/* istanbul ignore file */
import { CurrencyCode } from "#graphql/supergraphEnums";
import { DEFAULT_PRECISION } from "../Wallet/utils";
import { MoneyType } from "./types";

export const DEFAULT_BASE_MONEY_PROPS: MoneyType = {
  amount: 0,
  currency: CurrencyCode.Usd,
  precision: DEFAULT_PRECISION,
};

export const CURRENCY_CODE_TO_NAME_MAP: { [K in CurrencyCode]: string } = {
  USD: "U.S. Dollar",
  EUR: "Euro",
  JPY: "Japanese Yen",
  GBP: "British Pound",
  AUD: "Australian Dollar",
  CAD: "Canadian Dollar",
  CHF: "Swiss Franc",
  CNY: "Chinese Yuan Renminbi",
  SEK: "Swedish Krona",
  NZD: "New Zealand Dollar",
  MXN: "Mexican Peso",
  SGD: "Singapore Dollar",
  HKD: "Hong Kong Dollar",
  NOK: "Norwegian Krone",
  KRW: "South Korean Won",
  TRY: "Turkish Lira",
  RUB: "Russian Ruble",
  INR: "Indian Rupee",
  BRL: "Brazilian Real",
  ZAR: "South African Rand",
  DKK: "Danish Krone",
  COP: "Colombian Peso",
  VND: "Vietnamese Dong",
  TWD: "Taiwan New Dollar",
  PLN: "Polish Złoty",
  CZK: "Czech Koruna",
  RON: "Romanian Leu",
  UYU: "Uruguayan Peso",
  PEN: "Peruvian Sol",
  UAH: "Ukrainian Hryvnia",
  ARS: "Argentine Peso",
  CLP: "Chilean Peso",
  AED: "Emirati Dirham",
  THB: "Thai Bhat",
};

export enum CurrencyCodeEnum {
  USD = "USD",
  EUR = "EUR",
  JPY = "JPY",
  GBP = "GBP",
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
  CNY = "CNY",
  SEK = "SEK",
  NZD = "NZD",
  MXN = "MXN",
  SGD = "SGD",
  HKD = "HKD",
  NOK = "NOK",
  KRW = "KRW",
  TRY = "TRY",
  RUB = "RUB",
  INR = "INR",
  BRL = "BRL",
  ZAR = "ZAR",
  DKK = "DKK",
  COP = "COP",
  VND = "VND",
  TWD = "TWD",
  PLN = "PLN",
  CZK = "CZK",
  RON = "RON",
  UYU = "UYU",
  PEN = "PEN",
  UAH = "UAH",
  ARS = "ARS",
  CLP = "CLP",
  AED = "AED",
  THB = "THB",
}
